import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { time } from 'console';
import { timeout } from 'rxjs/operators';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';

@Component({
  selector: 'app-bonus-scheme-makercheker',
  templateUrl: './bonus-scheme-makercheker.component.html',
  styleUrls: ['./bonus-scheme-makercheker.component.scss']
})
export class BonusSchemeMakerchekerComponent implements OnInit {

  page: number = 1;
  schemeDetails: any[] = [];
  bonusPointsList: any[] = [];
  selectedBonusType: string = '';
  selectedBonusConfigType: string = '';
  getPaginationCount: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private xlsx: XlsxService
  ) { }

  ngOnInit(): void {
    this.getSchemeMakerCheckerDetails();
  }

  /** 🔹 Get Scheme Master List */
  getSchemeMakerCheckerDetails(): void {
    this.apiService.get(this.apiConfig.getBonusPointsConfigDetails).subscribe({
      next: (res: any) => {
        this.schemeDetails = res.data || [];
        console.log('Scheme Details:', this.schemeDetails);
      },
      error: (err) => {
        console.error('Error loading scheme details:', err);
      }
    });
  }

  /** 🔹 Get Bonus Points List Based on Filters */
  getBonusPointsList(): void {
    const typeId = this.selectedBonusType ? this.selectedBonusType : '';
    const redeemType = this.selectedBonusConfigType ? this.selectedBonusConfigType : '';

    const url = `${this.apiConfig.getBonusPointsAssignedUsers}&id=${typeId}&redeem_type=${redeemType}`;
    this.apiService.get(url).subscribe({
      next: (res: any) => {
        console.log('Bonus Points Response:', res);
        this.bonusPointsList = res.data || [];
        if (this.bonusPointsList.length > 0) {
          setTimeout(() => {
            document.getElementById('downloadTemplate').click();
          }, 500);
        }
      },
      error: (err) => {
        console.error('Error fetching bonus points list:', err);
      }
    });
  }

  /** 🔹 Download Template Button Action */
  downloadTemplate(): void {
    this.getBonusPointsList();
  }

  /** 🔹 Reset Filters */
  resetFilters(): void {
    this.selectedBonusType = '';
    this.selectedBonusConfigType = '';
    this.getBonusPointsList();
  }

  /** 🔹 Pagination Click */
  paginationClick(event: number): void {
    this.page = event;
    this.getBonusPointsList();
  }

  /** 🔹 Close All Modals */
  dismissModal(): void {
    this.modalService.dismissAll();
  }

  /** 🔹 Select Bonus Type */
  onBonusTypeChange(event: any): void {
    this.selectedBonusType = event.target.value;
    console.log('Selected Bonus Type:', this.selectedBonusType);
  }

  /** 🔹 Select Bonus Config Type */
  onBonusConfigTypeChange(event: any): void {
    this.selectedBonusConfigType = event.target.value;
    console.log('Selected Bonus Config Type:', this.selectedBonusConfigType);
  }
}
